import Container from '@mui/joy/Container';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import AspectRatio from '@mui/joy/AspectRatio';
import { typographyClasses } from '@mui/joy/Typography';
import { listClasses } from '@mui/joy/List';


import { InView } from 'react-intersection-observer';


export function ScreenContainerTwoPotato({
    children,
    window,
    onInView,
    view,
    onViewHook,
    reversed,
}: React.PropsWithChildren<{ reversed?: boolean, onInView?: (a: boolean, view: string) => void, window?: React.ReactNode | undefined, view: string, onViewHook?: () => void }>) {


    if (window === undefined) {
        window = <img
            src="https://images.unsplash.com/photo-1483791424735-e9ad0209eea2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
            alt=""
        />
    }

    return (
        <Container
            id={view}
            sx={(theme) => ({
                position: 'relative',
                minHeight: '100dvh',
                display: 'flex',
                flexDirection: reversed ? 'column-reverse' : 'column',
                justifyContent: reversed ? "flex-end" : "initial",
                alignItems: 'center',
                pt: 8,
                pb: 10,
                gap: 4,
                [theme.breakpoints.up(834)]: {
                    flexDirection: reversed ? 'row-reverse' : 'row',
                    gap: 6,
                },
                [theme.breakpoints.up(1199)]: {
                    gap: 12,
                },
            })}
        >

            <Box
                sx={(theme) => ({
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    maxWidth: '50ch',
                    textAlign: 'center',
                    flexShrink: 999,
                    [theme.breakpoints.up(834)]: {
                        minWidth: 420,
                        alignItems: 'flex-start',
                        textAlign: 'initial',
                    },
                    [`& .${typographyClasses.root}`]: {
                        // maxWidth: 300,
                        textAlign: 'initial',
                        textWrap: 'balance',
                    },
                    [`& .${listClasses.root}`]: {
                        // maxWidth: 300,
                        textAlign: 'initial',
                        textWrap: 'balance',
                    },
                })}
            >
                <InView as="div" onChange={(inView) => { onInView && onInView(inView, view); onViewHook && inView && onViewHook() }} >
                    <Stack
                        spacing={1}
                    >
                        {children}
                    </Stack>
                </InView>
            </Box>
            <AspectRatio
                ratio={600 / 520}
                variant="outlined"
                maxHeight={300}
                sx={(theme) => ({
                    minWidth: 300,
                    alignSelf: 'stretch',
                    [theme.breakpoints.up(834)]: {
                        alignSelf: 'initial',
                        flexGrow: 1,
                        '--AspectRatio-maxHeight': '520px',
                        '--AspectRatio-minHeight': '400px',
                    },
                    borderRadius: 'sm',
                    flexBasis: '50%',
                })}
            >{window}

            </AspectRatio>
        </Container>

    );
}

export function ScreenContainerOnePotato({
    children,
    reversed,
    onInView,
    view,
    onViewHook,
}: React.PropsWithChildren<{ reversed?: boolean, onInView?: (a: boolean, s: string) => void, view: string, onViewHook?: () => void }>) {
    return (
        <Container
            id={view}
            sx={(theme) => ({
                position: 'relative',
                minHeight: '100%',
                display: 'flex',
                flexDirection: reversed ? 'column-reverse' : 'column',
                alignItems: 'center',
                py: 10,
                pb: 20,
                gap: 4,
                [theme.breakpoints.up(834)]: {
                    flexDirection: 'row',
                    gap: 6,
                },
                [theme.breakpoints.up(1199)]: {
                    gap: 12,
                },
            })}
        >
            <Box
                sx={{

                    display: 'flex',
                    width: "100vw",
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >

                <InView as="div" onChange={(inView) => { onInView && onInView(inView, view); onViewHook && inView && onViewHook() }} >
                    {children}
                </InView>

            </Box>
        </Container>
    );



}
